// type
import { NavItemType } from 'types/menu';
import BellOutlined from '@ant-design/icons/BellOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import LinkOutlined from '@ant-design/icons/LinkOutlined';
import NotificationOutlined from '@ant-design/icons/NotificationOutlined';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const other: NavItemType = {
  id: 'other',
  type: 'group',
  children: [
    {
      id: 'announcements',
      title: 'announcements',
      type: 'item',
      icon: NotificationOutlined,
      url: '/announcements',
      rule: 'announcements.read'
    },
    {
      id: 'templates',
      title: 'templates',
      type: 'item',
      icon: FileTextOutlined,
      url: '/templates'
    },
    {
      id: 'obligation-notifications',
      title: 'obligation-notifications-customers',
      type: 'item',
      icon: LinkOutlined,
      url: '/notifications/obligations',
      rule: 'whatsapp.settings.read'
    },
    {
      id: 'whatsapp-notifications',
      title: 'whatsapp-notifications-log',
      type: 'item',
      icon: BellOutlined,
      url: '/whatsapp/notifications',
      rule: 'whatsapp.notifications.read'
    }
  ]
};

export default other;
